var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 46,
    viewBox: "0 0 28 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6332 44.6528C28.4556 42.8565 28.4556 39.9437 26.6332 38.1474L11.2662 23.0001L26.6332 7.85272C28.4556 6.05628 28.4556 3.14374 26.6332 1.3473C24.8107 -0.449099 21.8559 -0.449099 20.0335 1.3473L1.36675 19.7473C-0.455587 21.5438 -0.455587 24.4564 1.36675 26.2527L20.0335 44.6528C21.8559 46.4491 24.8107 46.4491 26.6332 44.6528Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/arrow1.0c89b5b635adf255c2822c630aaa6ccf.svg";
export { ForwardRef as ReactComponent };